export default "__VITE_ASSET__75baca95__"